import { types } from "../types/types";

export const getTransactions = (values) => ({
  type: types.getTransactions,
  payload: values,
});

export const getTransactionsTotalDocs = (values) => ({
    type: types.getTransactionsTotalDocs,
    payload: values,
  });

export const getTransactionsFilter = (values) => ({
  type: types.getTransactionsFilter,
  payload: values,
});  

export const getTransactionsBanks = (values) => ({
  type: types.getTransactionsBanks,
  payload: values,
});  

export const importTransactions = (state) => {
   return async (dispatch) => {
     try {
       dispatch(getTransactions(state))
     } catch(error) {
       console.error(error)
     }
   }
}

export const importTransactionsTotalDocs = (state) => {
    return async (dispatch) => {
      try {
        dispatch(getTransactionsTotalDocs(state))
      } catch(error) {
        console.error(error)
      }
    }
 }

 export const importTransactionsFilter = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getTransactionsFilter(state))
    } catch(error) {
      console.error(error)
    }
  }
} 

export const importTransactionsBanks = (state) => {
  return async (dispatch) => {
    try {
      dispatch(getTransactionsBanks(state))
    } catch(error) {
      console.error(error)
    }
  }
} 
 
export const updateTransactions = (values) => ({
  type: types.updateConciliacion,
  payload: values,
}); 
  
export const importUpdateTransactions = (state) => {
  return async (dispatch) => {
    try {
      dispatch(updateTransactions(state))
    } catch(error) {
      console.error(error)
    }
  }
} 